/* ==============================================================
   AIRVO AIR SOLUTIONS — theme script

   Loaded on every page. Everything below is null-guarded, so the
   subscription engine simply does nothing on pages that do not
   contain the pricing table or the quiz.

   Sections:
     1. Navigation (drawer + services dropdown)
     2. Quote form validation
     3. Modals + post-submit confirmation
     4. SUBSCRIPTION ENGINE — pricing, quiz and checkout.
        Section 4 is carried over from the previous build unchanged
        in behaviour. Do not alter it without re-testing checkout.
   ============================================================== */


/* ========================================================
   1. NAVIGATION
   ======================================================== */
(function nav(){
  var burger = document.getElementById('burger');
  var mnav   = document.getElementById('mnav');

  function closeDrawer(){
    if(!burger || !mnav) return;
    burger.classList.remove('on');
    burger.setAttribute('aria-expanded','false');
    mnav.classList.remove('open');
    document.body.classList.remove('locked');
  }

  if(burger && mnav){
    burger.addEventListener('click', function(){
      var open = !mnav.classList.contains('open');
      mnav.classList.toggle('open', open);
      burger.classList.toggle('on', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('locked', open);
    });
    mnav.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', closeDrawer);
    });
    window.addEventListener('resize', function(){
      if(window.innerWidth >= 900) closeDrawer();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') closeDrawer();
    });
  }

  /* Services dropdown — hover handles pointer users via CSS; this adds
     click and keyboard support for touch and screen-reader users. */
  var drop = document.getElementById('svcDrop');
  if(drop){
    var btn = drop.querySelector('button');
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var open = drop.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function(e){
      if(!drop.contains(e.target)){
        drop.classList.remove('open');
        btn.setAttribute('aria-expanded','false');
      }
    });
    drop.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        drop.classList.remove('open');
        btn.setAttribute('aria-expanded','false');
        btn.focus();
      }
    });
  }
})();


/* ========================================================
   2. QUOTE FORM
   Validates before handing off to Shopify's /contact endpoint so
   people get a useful message instead of a silent failed submit.
   ======================================================== */
(function quoteForms(){
  document.querySelectorAll('[data-quote-form]').forEach(function(form){
    var errBox = form.querySelector('[data-qerr]');

    function fail(msg, field){
      if(errBox){ errBox.textContent = msg; errBox.classList.add('show'); }
      if(field){ field.focus(); }
      return false;
    }

    form.addEventListener('submit', function(e){
      if(errBox) errBox.classList.remove('show');

      var name    = form.querySelector('input[name="contact[Name]"]');
      var phone   = form.querySelector('input[name="contact[Phone]"]');
      var email   = form.querySelector('input[name="contact[email]"]');
      var zip     = form.querySelector('input[name="contact[ZIP code]"]');
      var service = form.querySelector('select');

      if(!name.value.trim()){
        e.preventDefault(); return fail('Please add your name so we know who we are talking to.', name);
      }
      var digits = phone.value.replace(/\D/g,'');
      if(digits.length < 10){
        e.preventDefault(); return fail('Please enter a phone number we can reach you on.', phone);
      }
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())){
        e.preventDefault(); return fail('That email address does not look right — mind checking it?', email);
      }
      if(!/^\d{5}(-\d{4})?$/.test(zip.value.trim())){
        e.preventDefault(); return fail('Please enter a 5-digit ZIP code so we can confirm we cover your area.', zip);
      }
      if(!service.value){
        e.preventDefault(); return fail('Let us know which service you need.', service);
      }

      var submit = form.querySelector('button[type="submit"]');
      if(submit){
        submit.textContent = 'Sending…';
        submit.style.pointerEvents = 'none';
        submit.style.opacity = '.75';
      }
    });
  });
})();


/* ========================================================
   3. MODALS
   ======================================================== */
function syncModalLock(){
  document.body.classList.toggle('modal-open', !!document.querySelector('.airvo-modal.show'));
}

document.querySelectorAll('[data-open]').forEach(function(el){
  el.addEventListener('click', function(e){
    e.preventDefault();
    var m = document.getElementById(this.getAttribute('data-open'));
    if(m){ m.classList.add('show'); syncModalLock(); }
  });
});

document.addEventListener('click', function(e){
  var c = e.target.closest ? e.target.closest('[data-close]') : null;
  if(c){
    var m = document.getElementById(c.getAttribute('data-close'));
    if(m) m.classList.remove('show');
  }
  if(e.target.id === 'checkoutModal' || e.target.id === 'cpClose'){
    var cm = document.getElementById('checkoutModal');
    if(cm) cm.classList.remove('show');
  }
  if(e.target.classList && e.target.classList.contains('airvo-modal')){
    e.target.classList.remove('show');
  }
  syncModalLock();
});

document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){
    document.querySelectorAll('.airvo-modal.show').forEach(function(m){ m.classList.remove('show'); });
    syncModalLock();
  }
});

/* Shopify reloads with ?contact_posted=true after a contact/quote form sends */
(function(){
  try{
    var p = new URLSearchParams(window.location.search);
    if(p.get('contact_posted') === 'true'){
      var m = document.getElementById('sentModal');
      if(m){ m.classList.add('show'); syncModalLock(); }
      history.replaceState(null, '', window.location.pathname);
    }
  }catch(e){}
})();


/* ==============================================================
   4. SUBSCRIPTION ENGINE
   ==============================================================
   AIRVO PRICING — THE ONLY PLACE PRICES ARE DEFINED.
   [ monthly, every 2 months, every 3 months ]
   Plan cards, toggle labels, quiz totals and the checkout preview
   all read from here. Change a number once.

   NOTE: this controls the MARKETING pages only. The price a
   customer actually pays comes from the product record in
   Shopify admin — keep the two in sync.
   ============================================================== */
const AIRVO_PRICING = {
  'Basic Home'     : [21.99, 20.99, 19.79],
  'Family & Pets'  : [24.99, 23.99, 22.49],
  'Allergy & Smoke': [29.99, 28.79, 26.99]
};
const AIRVO_EXTRA_OFF = 0.10;   /* each additional filter is 10% off */
const AIRVO_KEYS = { basic:'Basic Home', family:'Family & Pets', pets:'Allergy & Smoke' };

function airvoMoney(n){ return '$' + n.toFixed(2); }
function airvoSaving(plan, idx){
  const p = AIRVO_PRICING[plan];
  return Math.floor((p[0] - p[idx]) / p[0] * 100);
}
function airvoMinSaving(idx){
  return Math.min.apply(null, Object.keys(AIRVO_PRICING).map(function(k){ return airvoSaving(k, idx); }));
}
/* total for a delivery, applying the advertised multi-filter discount */
function airvoDeliveryTotal(plan, idx, qty){
  const u = AIRVO_PRICING[plan][idx];
  return u + u * (1 - AIRVO_EXTRA_OFF) * (Math.max(1, qty) - 1);
}
function airvoLowest(){
  let lo = Infinity;
  Object.keys(AIRVO_PRICING).forEach(function(k){
    AIRVO_PRICING[k].forEach(function(v){ if (v < lo) lo = v; });
  });
  return lo;
}

/* write every marketing price from AIRVO_PRICING so nothing can drift */
(function applyPricing(){
  document.querySelectorAll('.plan[data-plan-key]').forEach(function(card){
    const plan = AIRVO_KEYS[card.dataset.planKey];
    if (!plan) return;
    const p = AIRVO_PRICING[plan];
    const amt = card.querySelector('.amt');
    if (amt){
      amt.dataset.prices = p.map(function(v){ return v.toFixed(2); }).join('|');
      amt.textContent = p[0].toFixed(2);
    }
    const note = card.querySelector('.freq-note');
    if (note){
      note.dataset.notes = [
        'Billed monthly',
        'Every 2 months \u00b7 save ' + airvoSaving(plan, 1) + '%',
        'Every 3 months \u00b7 save ' + airvoSaving(plan, 2) + '%'
      ].join('|');
      note.textContent = 'Billed monthly';
    }
  });
  const tg = document.getElementById('billingToggle');
  if (tg){
    const labels = tg.querySelectorAll('button .save');
    if (labels[0]) labels[0].textContent = 'Save ' + airvoMinSaving(1) + '%';
    if (labels[1]) labels[1].textContent = 'Save ' + airvoMinSaving(2) + '%';
  }
  document.querySelectorAll('[data-airvo-from]').forEach(function(el){
    el.textContent = airvoMoney(airvoLowest());
  });
})();

/* ---- Pricing billing toggle ---- */
const toggle = document.getElementById('billingToggle');
if(toggle) toggle.addEventListener('click', e => {
  const btn = e.target.closest('button'); if(!btn) return;
  toggle.querySelectorAll('button').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const f = +btn.dataset.freq;
  document.querySelectorAll('.plan .amt').forEach(a => { a.textContent = a.dataset.prices.split('|')[f]; });
  document.querySelectorAll('.plan .freq-note').forEach(n => { n.textContent = n.dataset.notes.split('|')[f]; });
});

/* ================= QUIZ ================= */
const answers = {};
const steps   = document.querySelectorAll('.q-step');
const bar     = document.getElementById('qBar');
const backBtn = document.getElementById('qBack');
const result  = document.getElementById('qResult');
const qNav    = document.getElementById('qNav');
let cur = 0;
const TOTAL = steps.length;

function show(i){
  if(!steps.length) return;
  steps.forEach((s,idx) => s.classList.toggle('active', idx === i));
  if(bar) bar.style.width = (((i + 0.5) / TOTAL) * 100) + '%';
  if(backBtn) backBtn.disabled = i === 0;
}
function selectOpt(stepEl, btn){
  const key = stepEl.querySelector('.q-options').dataset.key;
  stepEl.querySelectorAll('.q-opt').forEach(o => o.classList.remove('sel'));
  btn.classList.add('sel');
  answers[key] = btn.dataset.val;
  setTimeout(() => {
    if(cur < TOTAL - 1){ cur++; show(cur); }
    else { computeResult(); }
  }, 230);
}
steps.forEach(stepEl => {
  stepEl.querySelectorAll('.q-opt').forEach(btn => {
    btn.addEventListener('click', () => selectOpt(stepEl, btn));
  });
});
if(backBtn) backBtn.addEventListener('click', () => { if(cur > 0){ cur--; show(cur); } });

/* ---- Recommendation logic ------------------------------------------------
   Grounded in ASHRAE 52.2, which scores filters in three particle bands:
     E3  3.0–10 um  household dust, lint, pollen, mold spores      -> MERV 8
     E2  1.0–3.0 um fine dust, PET DANDER, auto emissions          -> MERV 11
     E1  0.3–1.0 um fine allergens, bacteria, SMOKE particulate    -> MERV 13

   Filtration need and system tolerance are decided separately, then combined.
   Denser media raises static pressure; a 1" MERV 13 is the riskiest common
   case, and an older single-speed blower has the least headroom. So when a
   home needs MERV 13 but the system can't safely take it, we step down and
   say why rather than selling a filter that may starve the equipment.
-------------------------------------------------------------------------- */
const AIRVO_TIER = { 8:'Basic Home', 11:'Family & Pets', 13:'Allergy & Smoke' };

function airvoNeed(a){
  if(a.allergies === 'yes' || a.smoke === 'yes') return 13;   // E1 capture required
  if(a.pets === 'yes')                           return 11;   // E2 capture required
  return 8;                                                   // E3 is enough
}
function airvoCap(a){
  if(a.thickness === 'thick') return 13;                      // depth removes the constraint
  if(a.thickness === '1' && a.system === 'new') return 13;    // 1" + modern ECM blower
  return 11;                                                  // older, weak, or unknown
}

function computeResult(){
  const a = answers;
  const need = airvoNeed(a), cap = airvoCap(a);
  const merv = Math.min(need, cap);
  const plan = AIRVO_TIER[merv];
  const stepped = need > cap;

  let why;
  if(merv === 13){
    why = (a.allergies === 'yes' && a.smoke === 'yes')
      ? 'Allergies plus smoke exposure both call for the finest filtration we carry. MERV 13 is the only tier rated in the 0.3–1 micron band where fine allergens and smoke particulate sit.'
      : (a.allergies === 'yes'
        ? 'For allergy and asthma households, MERV 13 is the tier that reaches the 0.3–1 micron band — fine pollen fragments, mould spores and the particles lower ratings pass straight through.'
        : 'Smoke and traffic particulate are the smallest things we filter, sitting in the 0.3–1 micron band. MERV 13 is the only tier rated to capture them.');
  } else if(merv === 11){
    why = (a.pets === 'yes')
      ? 'Pet dander sits in the 1–3 micron band, which MERV 11 captures well — along with fine dust — without choking your system the way a denser filter can.'
      : 'MERV 11 steps up capture of fine dust and everyday particulate while keeping airflow comfortable for your system.';
  } else {
    why = 'No allergies, no pets, no smoke exposure — MERV 8 captures the dust, lint, pollen and mould spores that most homes actually deal with, and keeps airflow wide open. A denser filter would restrict your system without a clear benefit.';
  }

  // Airflow caveat — shown only when we deliberately stepped the rating down
  let note = '';
  if(stepped){
    note = (a.thickness === 'unsure' || a.system === 'unsure')
      ? 'We\u2019ve recommended MERV 11 rather than MERV 13 because we don\u2019t yet know your filter thickness and system age. A 1-inch MERV 13 restricts airflow noticeably, and on an older blower that can reduce capacity or strain the motor. Tell us your setup at support@airvoair.com and we\u2019ll confirm whether MERV 13 is safe for you.'
      : 'Your home would benefit from MERV 13, but a 1-inch MERV 13 in an older or weaker-airflow system can restrict airflow enough to cut capacity and strain the blower. MERV 11 gives you most of the benefit safely. If a technician has confirmed your system handles high-efficiency filters, you can choose Allergy & Smoke instead.';
  }

  const schedIdx = (typeof rFreqIdx === 'number') ? rFreqIdx : 1;
  const schedule = ['Monthly','Every 2 months','Every 3 months'][schedIdx];
  const count = rQty || 1;
  const unit  = AIRVO_PRICING[plan][schedIdx];
  const total = airvoDeliveryTotal(plan, schedIdx, count).toFixed(2);
  lastRec = { plan:plan, merv:'MERV ' + merv, schedule:schedule, qty:count, unit:unit };

  const set = (id, v) => { const el = document.getElementById(id); if(el) el.textContent = v; };
  set('rMerv','MERV ' + merv);
  set('rPlan', plan);
  set('rPlanName', plan + ' (MERV ' + merv + ')');
  set('rWhy', why);
  set('rCount', count + (count > 1 ? ' filters' : ' filter'));
  set('rSchedule', schedule);
  set('rTotal','$' + total);

  const noteEl = document.getElementById('rNote');
  if(noteEl){ noteEl.textContent = note; noteEl.style.display = note ? 'block' : 'none'; }

  steps.forEach(s => s.classList.remove('active'));
  if(qNav) qNav.style.display = 'none';
  if(result) result.classList.add('show');
  if(bar) bar.style.width = '100%';
}

/* quantity + delivery are order options, chosen on the result screen */
let rQty = 1, rFreqIdx = 1;
function wirePicker(id, attr, onPick){
  const box = document.getElementById(id); if(!box) return;
  box.querySelectorAll('button').forEach(b => {
    b.addEventListener('click', () => {
      box.querySelectorAll('button').forEach(x => x.classList.remove('on'));
      b.classList.add('on');
      onPick(+b.dataset[attr]);
      if(Object.keys(answers).length >= 5) computeResult();
    });
  });
}
wirePicker('rQtyPick','qty', v => { rQty = v; });
wirePicker('rFreqPick','freq', v => { rFreqIdx = v; });

const qRestartBtn = document.getElementById('qRestart');
if(qRestartBtn) qRestartBtn.addEventListener('click', () => {
  Object.keys(answers).forEach(k => delete answers[k]);
  document.querySelectorAll('.q-opt').forEach(o => o.classList.remove('sel'));
  document.querySelectorAll('.r-size-chip').forEach(c => c.classList.remove('sel'));
  const si = document.getElementById('rSizeInput');
  const sl = document.getElementById('rSizeLine');
  if(si) si.value = '';
  if(sl) sl.style.display = 'none';
  if(result) result.classList.remove('show');
  if(qNav) qNav.style.display = 'flex';
  cur = 0; show(0);
});

/* ---- Size entry on the result screen ---- */
const sizeInput = document.getElementById('rSizeInput');
const sizeLine  = document.getElementById('rSizeLine');
const sizeVal   = document.getElementById('rSizeVal');
function setSize(val){
  const v = (val || '').trim();
  if(v && sizeVal && sizeLine){ sizeVal.textContent = v; sizeLine.style.display = 'flex'; }
  else if(sizeLine){ sizeLine.style.display = 'none'; }
}
if(sizeInput) document.querySelectorAll('.r-size-chip').forEach(chip => {
  chip.addEventListener('click', () => {
    document.querySelectorAll('.r-size-chip').forEach(c => c.classList.remove('sel'));
    chip.classList.add('sel');
    const s = chip.dataset.size === '__unsure' ? '' : chip.dataset.size;
    sizeInput.value = s;
    setSize(s);
  });
});
if(sizeInput) sizeInput.addEventListener('input', () => {
  document.querySelectorAll('.r-size-chip').forEach(c => {
    c.classList.toggle('sel', c.dataset.size.toLowerCase() === sizeInput.value.trim().toLowerCase());
  });
  setSize(sizeInput.value);
});

/* ================= CHECKOUT ================= */
let lastRec = null;
const IS_SHOPIFY = typeof window.Shopify !== 'undefined';

/* ── CONNECT YOUR PRODUCTS ───────────────────────────────────────────────────
   Create 3 subscription products in Shopify with these exact handles (or change
   the handles below to match yours). Add your filter sizes as variants and your
   delivery frequencies as subscription/selling plans.

   That's it — the button automatically looks up the product, matches the size to
   a variant, picks the right delivery plan, adds it to the cart, and sends the
   customer STRAIGHT TO CHECKOUT. No variant IDs to copy by hand.

   (Optional) If your selling-plan names don't contain "month", paste the exact
   selling-plan IDs into sellingPlans below to force the right match. */
const AIRVO = {
  plans: {
    'Basic Home':      { handle:'basic-home',    sellingPlans:{ 'Monthly':'', 'Every 2 months':'', 'Every 3 months':'' } },
    'Family & Pets':   { handle:'family-home',   sellingPlans:{ 'Monthly':'', 'Every 2 months':'', 'Every 3 months':'' } },
    'Allergy & Smoke': { handle:'pets-allergies', sellingPlans:{ 'Monthly':'', 'Every 2 months':'', 'Every 3 months':'' } }
  }
};

function freqFromToggle(){
  if(!toggle) return 'Monthly';
  const active = toggle.querySelector('button.active');
  const f = active ? +active.dataset.freq : 0;
  return ['Monthly','Every 2 months','Every 3 months'][f] || 'Monthly';
}
function norm(s){ return (s || '').toString().toLowerCase().replace(/[^a-z0-9]/g,''); }

/* Find the variant that matches the customer's size, handling single-variant products too */
function pickVariant(product, size){
  if(!product || !product.variants || !product.variants.length) return null;
  if(product.variants.length === 1) return product.variants[0]; // size tracked as a property
  const want = norm(size);
  if(want){
    const m = product.variants.find(v => norm(v.title).includes(want) || (v.options || []).some(o => norm(o) === want));
    if(m) return m;
  }
  return null; // no size match → let the customer choose on the product page
}

/* Resolve the subscription selling plan for the chosen frequency */
function pickSellingPlan(cfg, product, schedule){
  if(cfg.sellingPlans[schedule]) return cfg.sellingPlans[schedule];        // 1) configured ID wins
  const groups = (product && product.selling_plan_groups) || [];
  const plans = groups.flatMap(g => g.selling_plans || []);
  if(!plans.length) return '';
  const kw = { 'Monthly':/month/i, 'Every 2 months':/(2|two)\s*month/i, 'Every 3 months':/(3|three)\s*month/i }[schedule];
  if(schedule === 'Monthly'){ const p = plans.find(p => /month/i.test(p.name) && !/[23]|two|three/i.test(p.name)); if(p) return p.id; }
  else if(kw){ const p = plans.find(p => kw.test(p.name)); if(p) return p.id; }
  const idx = ['Monthly','Every 2 months','Every 3 months'].indexOf(schedule);   // 3) fall back to order created
  return (plans[idx] || plans[0]).id;
}

async function getProduct(handle){
  try{
    const r = await fetch('/products/' + handle + '.js', { headers:{ 'Accept':'application/json' } });
    if(r.ok) return await r.json();
  }catch(e){}
  return null; // product doesn't exist yet
}

async function startCheckout(plan, schedule, qty, size, btn){
  const cfg = AIRVO.plans[plan]; if(!cfg) return;

  // Outside a live Shopify store → show the preview of what checkout will receive
  if(!IS_SHOPIFY){ showCheckoutPreview(plan, schedule, qty, size); return; }

  const setLoading = on => { if(!btn) return; if(on){ btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = 'Setting up your order…'; btn.style.pointerEvents = 'none'; btn.style.opacity = '.7'; } else { btn.textContent = btn.dataset.label || btn.textContent; btn.style.pointerEvents = ''; btn.style.opacity = ''; } };
  setLoading(true);

  // Look up the real product BEFORE navigating anywhere (prevents 404s)
  const product = await getProduct(cfg.handle);
  if(!product){ setLoading(false); showSetupNeeded(plan); return; }

  const variant = pickVariant(product, size);
  const sellingPlan = pickSellingPlan(cfg, product, schedule);

  // Matched a specific variant (or single-variant product) → add to cart + go straight to checkout
  if(variant){
    const item = { id:variant.id, quantity:qty,
      properties:{ 'Recommended plan':plan, 'Filter size':(size && size.trim()) ? size.trim() : 'To confirm', 'Delivery':schedule } };
    if(sellingPlan) item.selling_plan = sellingPlan;
    try{
      const r = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ items:[item] }) });
      if(r.ok){ window.location.href = '/checkout'; return; }
    }catch(e){}
  }

  // Product exists but we couldn't lock the exact size → send to the real product page to confirm size
  const u = new URL('/products/' + cfg.handle, window.location.origin);
  if(sellingPlan) u.searchParams.set('selling_plan', sellingPlan);
  if(size && size.trim()) u.searchParams.set('size', size.trim());
  window.location.href = u.toString();
}

/* pick the first available variant as a fallback when the size isn't a stocked variant */
function firstAvailable(product){
  if(!product || !product.variants || !product.variants.length) return null;
  return product.variants.find(v => v.available) || product.variants[0];
}

/* QUIZ path → always add to cart and go STRAIGHT to checkout.
   The customer's size is written to the order note (and a line-item property)
   so it shows on the order/invoice — even when it isn't a stocked size. */
async function quizCheckout(rec, size, btn){
  const cfg = AIRVO.plans[rec.plan]; if(!cfg) return;
  if(!IS_SHOPIFY){ showCheckoutPreview(rec.plan, rec.schedule, rec.qty, size); return; }
  const setLoading = on => { if(!btn) return; if(on){ btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = 'Setting up your order…'; btn.style.pointerEvents = 'none'; btn.style.opacity = '.7'; } else { btn.textContent = btn.dataset.label || btn.textContent; btn.style.pointerEvents = ''; btn.style.opacity = ''; } };
  setLoading(true);

  const product = await getProduct(cfg.handle);
  if(!product){ setLoading(false); showSetupNeeded(rec.plan); return; }

  const matched = pickVariant(product, size);
  const variant = matched || firstAvailable(product);
  if(!variant){ setLoading(false); showSetupNeeded(rec.plan); return; }
  const sellingPlan = pickSellingPlan(cfg, product, rec.schedule);

  const cleanSize = (size && size.trim()) ? size.trim() : '';
  const nonStandard = cleanSize && !matched && product.variants.length > 1;

  const props = { 'Plan':rec.plan + ' (' + rec.merv + ')', 'Delivery':rec.schedule,
                  'Filter size': cleanSize || 'To be confirmed' };
  const item = { id:variant.id, quantity:rec.qty, properties:props };
  if(sellingPlan) item.selling_plan = sellingPlan;

  try{
    const add = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ items:[item] }) });
    if(!add.ok) throw 0;
    // Order note — visible on the order/invoice in Shopify admin. Always records the size.
    let note = 'AIRVO order — ' + rec.plan + ' (' + rec.merv + '), ' + rec.schedule + ', qty ' + rec.qty + '. ';
    note += cleanSize ? ('Requested filter size: ' + cleanSize + '.') : 'Filter size to be confirmed with customer.';
    if(nonStandard) note += ' ** NON-STANDARD SIZE — please fulfill at the requested size above. **';
    await fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ note:note }) });
    window.location.href = '/checkout';
  }catch(e){ setLoading(false); alert('Sorry, something went wrong starting your subscription. Please try again.'); }
}

/* friendly message when the matching product hasn't been created in Shopify yet */
function showSetupNeeded(plan){
  const set = (id,v) => { const el = document.getElementById(id); if(el) el.textContent = v; };
  set('cpPlan', plan); set('cpFreq','—'); set('cpQty','—'); set('cpSize','—'); set('cpTotal','—');
  const modal = document.getElementById('checkoutModal'); if(!modal) return;
  modal.querySelector('h3').textContent = 'Almost ready';
  modal.querySelector('.sub').textContent = 'This plan isn\u2019t connected to a product yet.';
  modal.querySelector('.airvo-modal-sum').style.display = 'none';
  modal.querySelector('.airvo-modal-note').textContent = 'To take live orders, create a product in Shopify with the handle "' + (AIRVO.plans[plan].handle) + '" and its delivery options. Once it exists, this button adds it to the cart and goes straight to checkout automatically.';
  modal.classList.add('show'); syncModalLock();
}

/* preview modal — only appears outside a live Shopify store */
function showCheckoutPreview(plan, schedule, qty, size){
  const _i = Math.max(0, ['Monthly','Every 2 months','Every 3 months'].indexOf(schedule));
  const total = airvoDeliveryTotal(plan, _i, qty).toFixed(2);
  const set = (id,v) => { const el = document.getElementById(id); if(el) el.textContent = v; };
  set('cpPlan', plan);
  set('cpFreq', schedule);
  set('cpQty', qty + (qty > 1 ? ' filters' : ' filter'));
  set('cpSize', (size && size.trim()) ? size.trim() : 'To confirm');
  set('cpTotal', '$' + total);
  const m = document.getElementById('checkoutModal');
  if(m){ m.classList.add('show'); syncModalLock(); }
}

/* result CTA → straight to checkout with the recommended plan + size in order notes */
const rCheckoutBtn = document.getElementById('rCheckout');
if(rCheckoutBtn) rCheckoutBtn.addEventListener('click', function(e){
  e.preventDefault();
  if(!lastRec) return;
  quizCheckout(lastRec, sizeInput ? sizeInput.value : '', this);
});

/* plan-grid CTAs → checkout for the chosen plan at the selected frequency */
document.querySelectorAll('.plan-cta').forEach(b => {
  b.addEventListener('click', function(e){
    e.preventDefault();
    const plan = this.dataset.plan.replace('&amp;','&');
    startCheckout(plan, freqFromToggle(), (lastRec && lastRec.qty) || 1, (sizeInput ? sizeInput.value : ''), this);
  });
});

show(0);
